{
  "valid": "صالح"
}
